// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CallCenterModelNamesEnum {
  VehicleRegisterVehicle = "vehicleRegisterVehicle",
  Exemptions = "exemptions",
  EmailMessage = "emailMessage",
  Charges = "charges",
}
export default CallCenterModelNamesEnum;
